import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/facebook-f': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M279.1 288h-74.7v224h-100.2v-224h-81.4v-92.7h81.4v-70.6c0-80.3 47.9-124.7 121.1-124.7 35.1 0 71.8 6.3 71.8 6.3v78.9h-40.4c-39.8 0-52.2 24.7-52.2 50.1v60.1h88.9z'
      }
    ]
  }
})
